import { useContext } from 'react';
import { assert } from 'ts-essentials';

import { FeatureFlagsContext } from '../context';

export const useFeatureFlags = () => {
  const { companyFeatureFlags } = useContext(FeatureFlagsContext);

  assert(
    companyFeatureFlags,
    '`useFeatureFlagsContext` must be used inside of a `FeatureFlagsContext`.',
  );

  return companyFeatureFlags;
};
